import {Component, OnInit, Input} from '@angular/core';
import {getCurrencySymbol} from '@angular/common';
import {Observable, Subscription} from 'rxjs';
import {PriceDTO, StockDTO} from '@signature-it/ngx-catalogue/models';
import {Store} from '@ngrx/store';
import * as fromSelectors from '@signature-it/ngx-catalogue/store/selectors';

declare let _: any;

@Component({
    selector: 'add-product-btn',
    templateUrl: './add-product.html',
    styleUrls: ['./add-product.scss'],
    standalone: false
})
export class AddProductComponent implements  OnInit {

    // @Input() btnText: string;
    @Input() productId: number;
    @Input() productSku: string;
    @Input() mode: string = 'center';
    @Input() skuText: string;
    @Input() fixedLotMultiplier: number;

    //@Input() maxQty: number;
    protected subscriptionsList$: Array<Subscription> = [];
    priceList$: Observable<PriceDTO[]>;
    stockList$: Observable<StockDTO[]>;
    loadingTpl$: Observable<boolean>;
    isPrice: boolean = false;
    maxQty: number;
    minQty: number = 1;

    constructor(protected store$: Store<any>) {
        this.stockList$ = this.store$.select(fromSelectors.getCatalogueStockList);
        this.priceList$ = this.store$.select(fromSelectors.getCataloguePriceList);
        this.loadingTpl$ = this.store$.select(fromSelectors.getLoadingPriceList);
    }

    ngOnInit() {
        let sb1$ = this.priceList$.subscribe((priceList: PriceDTO[]) => {
            if(priceList && priceList.length) {
                let price = _.filter(Array.from(priceList), {'id': this.productId.toString() })[0];
                this.isPrice = price && price.value !== -1;
            }
        });
        this.subscriptionsList$.push(sb1$);
        let sb2$ = this.stockList$.subscribe((stockList: StockDTO[]) => {
            if (stockList && stockList.length) {
                let productStock =  _.filter(Array.from(stockList), {'productCode': this.productSku});
                if(productStock && productStock[0]) {
                    this.maxQty = productStock[0]['stock'];
                    if(!this.maxQty) {
                        this.minQty = 0;
                    }
                }
            }
        });
        this.subscriptionsList$.push(sb2$);
    }

}
